import { Link } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import courseImage from "../../../../Images/courseImage.png";

const TopHeroMarquee = ({ data }) => {
  const marqueeData = [...data, ...data];

  return (
    <div className="w-full overflow-hidden h-full">
      <div className="marquee whitespace-nowrap">
        
        <div className="inline-flex gap-6">
          {marqueeData.map((e, index) => {
            const cardStyles = [
              "bg-[#EDE7F6] text-[#34163F] border border-[#4B2D83]",
              "bg-[#F5A623] text-white border border-white",
              "bg-gradient-to-r from-[#4B2D83] to-[#6B4BB5] text-white border border-[#4B2D83]",
            ];

            const tagStyles = [
              "border-[#4B2D83] text-[#34163F]",
              "border-[#F5A623] text-white border border-white",
              "border-[#F5A612] text-white",
            ];

            const buttonStyles = [
              "bg-[#34163F] text-white",
              "bg-white text-[#34163F]",
              "bg-orange-300 text-white",
            ];

            const type = index % 3;

            return (
              <div
                key={`${e._id}-${index}`}
                className={`
                  relative
                  min-w-[300px]
                  sm:min-w-[340px]
                  lg:min-w-[340px]
                  lg:h-[200px]
                  sm:h-[150px]
                  rounded-2xl
                  px-5
                  py-2
                  flex
                  justify-between
                  items-start
                  shadow-md
                  ${cardStyles[type]}
                `}
              >
                {/* LEFT CONTENT */}
                <div className="flex flex-col gap-2 z-10">
                  <h2 className="text-lg sm:text-xl font-bold leading-tight">
                    {e.planName}
                  </h2>

                  <div className="flex gap-2 mt-0 flex-wrap">
                    {e.exams?.slice(0, 4).map((exam) => (
                      <span
                        key={exam._id || exam.examName}
                        className={`px-3 py-1 text-xs rounded-full border ${tagStyles[type]}`}
                      >
                        {exam.examName}
                      </span>
                    ))}
                  </div>

                  <div className="mt-2 flex items-center gap-3">
                    <span className="text-2xl font-bold">
                      ₹{e.offerPrice}
                    </span>

                    <span className="line-through text-sm opacity-70">
                      ₹{e.price}
                    </span>
                  </div>

                  <Link to={`/dash/checkout/${e._id}`}>
                    <button
                      className={`
                        mt-3
                        flex
                        items-center
                        gap-2
                        px-5
                        py-2
                        rounded-full
                        text-sm
                        font-medium
                        transition
                        ${buttonStyles[type]}
                      `}
                    >
                      View Course
                      <FaAngleRight />
                    </button>
                  </Link>
                </div>

                {/* IMAGE */}
                <div className="absolute bottom-0 right-4">
                  <img
                    src={courseImage}
                    alt="course"
                    className="w-28 h-28 object-contain opacity-90"
                  />
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default TopHeroMarquee;